/* 龐德（字令明） ---- 魏將補強（2026-10-02，原創；設計見 docs/HEROES-WEI14.md）---- */
import { spMul, sigOf } from '../../core/kit.ts';
import type { Unit } from '../types.ts';
import { defineHero, hook, S, D } from '../define.ts';

export default defineHero({
  id: 'pangde', name: '龐德', sub: '字令明', faction: 'wei', role: '坦克', weapon: 'guandao',
  look: { weaponName: '大刀', beard: 'bushy', eye: 'fierce', skin: '#c8905e', bulk: 1.12, fx: '#eef0f6', c: { plume: '#f2f2f2', cape: '#e6e6ea', armor: '#4a5a7a' } },
  skills: [
    ['白馬突', 'charge', '騎白馬向前衝鋒，沿途敵人受到 {70/110/150/190} 傷害並被擊退。', { x: { dmg: [70, 110, 150, 190], cc: { knockback: 60 }, speed: 560 }, aim: D(360, 56), cd: 12, mp: [70, 80, 90, 100], el: null }],
    ['射額', 'bolt', '朝方向射出長箭，穿過小兵，命中的第一名敵將受到 {60/100/140/180} 傷害並被嘲諷 {1/1.15/1.3/1.5} 秒，只能朝龐德走來。', { x: { k: 'tauntshot', dmg: [60, 100, 140, 180], taunt: [1, 1.15, 1.3, 1.5] }, aim: D(900, 20), cd: [16, 14, 12, 10], mp: 80, el: null }],
    ['不降', 'passive', '每次受到控制，3 秒內防禦 +{4/6/8/10}，控制時間 -{10/15/20/25}%。', { pv: {}, sig: 'unyield', armor: [4, 6, 8, 10], ten: [10, 15, 20, 25] }],
    ['抬櫬死戰', 'buff', '抬棺出戰 {4/5/6} 秒：生命不會低於 1；結束時依期間造成的傷害回復 {40/60/80}% 生命。', { x: { k: 'coffin', dur: [4, 5, 6], back: [40, 60, 80] }, aim: S(0), cd: [90, 80, 70], mp: [100, 125, 150], el: 'shadow', shout: '我今抬櫬而來，有死而已！' }],
  ],
  // 專屬技能（技能資料裡的 x.k）
  kinds: {
    tauntshot(u, a, X) {
      this.shootProj(u, { dir: a.dir, speed: 1300, range: this.skillRange(a.sk, a.lvl), rad: 22, shape: 'arrow', big: true, col: u.spec.fx,
        filter: (t: Unit) => t.kind === 'hero',
        onHit: (t: Unit) => { this.damage(u, t, X.dmg * spMul(u), { magic: true, spell: true, stagger: 0.3 }); this.applyCC(u, t, { taunt: X.taunt }); this.fx({ k: 'spark', x: t.x, y: t.y - 60, col: '#ff6a5a' }); return true; } });
    },
    coffin(u, a, X) {
      u.coffinT = this.t + X.dur; u.coffinDmg = 0;
      this.say(`${u.name} 抬櫬死戰！`, 'info');
      this.fx({ k: 'slam', x: u.x, y: u.y, col: '#b07cff' });
      this.later(X.dur, () => {
        if (!u.alive) return;
        const h = u.coffinDmg * X.back / 100;
        this.heal(u, h); this.fx({ k: 'heal', x: u.x, y: u.y, col: u.spec.fx });
        if (u.human) this.tell(u, `抬櫬死戰結束：回復 ${Math.round(h)} 生命`, 'info');
      });
    },
  },
  // 被動與專屬效果：hook(時間點, 順位, 處理)（時間點一覽見 core/hooks.ts）
  hooks: [
    // 抬櫬死戰：記錄期間打出的傷害，結束時回血
    hook('damage.after', 50, function (c, lost) { const own = c.own; if (own.coffinT > this.t && c.t.team !== own.team) own.coffinDmg += lost; }),
    // 抬櫬死戰：期間生命不會低於 1
    hook('preKill', 10, function (src, t) { if (t.coffinT > this.t) { t.hp = 1; return true; } }),
    // 不降：硬控制時間縮短
    hook('cc.tenacity', 10, function (t, cc) { const un = sigOf(t, 'unyield'); return un ? un.v('ten') : 0; }),
    // 不降：被控制後加護甲
    hook('cc.after', 10, function (t, cc) { const un = cc && t.alive ? sigOf(t, 'unyield') : null; if (un) this.addBuff(t, { id: 'unyield', t: 3, armor: un.v('armor') }); }),
    hook('revive', 50, function (u) { u.coffinT = 0; }),
  ],
  // 電腦什麼時候放這招
  ai: {
    tauntshot: ({ w, u, t, d, hero, hpR, foeHeroes }) => hero && d < 850,
    coffin: ({ w, u, t, d, hero, hpR, foeHeroes }) => hpR < 0.45 && foeHeroes(500) > 0,
  },
});
